import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { MDVIP_INVOICE_SLOGAN, MDVIP_SLOGAN } from '../../Constants'
import styles from './Main.module.scss'

export const SloganProvider: React.FC<{ isInvoice: boolean }> = ({ isInvoice }) => {
  const [slogan, setSlogan] = useState(MDVIP_SLOGAN)
  const location = useLocation()

  useEffect(() => {
    if (isInvoice && location.pathname === '/') {
      setSlogan(MDVIP_INVOICE_SLOGAN)
    } else {
      setSlogan(MDVIP_SLOGAN)
    }
  }, [isInvoice, location.pathname])

  return (
    <div>
      <h1 className={styles.heading}>Express Pay</h1>
      <div className={styles.slogan}>{slogan}</div>
      <hr className={styles.divider} />
    </div>
  )
}
